import {createAction, props} from '@ngrx/store';
import {CommerceErrorInterface} from '../common/error-handling/commerce-error';
import {AddressFormGroup} from '../data/model/address.model';

export interface AddressActionProps {
  address: AddressFormGroup;
}

export const setEnableAddressCollection = createAction(
  '[Address] Set enable address collection',
  props<{enabled: boolean}>(),
);

export const setVerifiedAddressRequired = createAction(
  '[Address] Set verified address required',
  props<{required: boolean}>(),
);

export const addOriginalAddress = createAction(
  '[Address] Add original address',
  props<AddressActionProps>(),
);

export const saveValidatedAddress = createAction(
  '[Address] Save validated address',
  props<AddressActionProps>(),
);

export const addSuggestedAddress = createAction(
  '[Address] Add suggested address',
  props<AddressActionProps>(),
);

export const createAddress = createAction('[Address] create address');

export const createAddressFailure = createAction(
  '[Address] create address failure',
  props<{error: CommerceErrorInterface}>(),
);

export const createAddressSuccess = createAction(
  '[Address] create address success',
  props<{id: string}>(),
);

export const submitAddress = createAction('[Address] submit address');

export const submitAddressFailure = createAction(
  '[Address] submit address failure',
  props<{error: CommerceErrorInterface}>(),
);

export const submitAddressSuccess = createAction(
  '[Address] submit address success',
);

export const loadSuggestedAddressFailure = createAction(
  '[Address] Load suggested address failure',
  props<{error: CommerceErrorInterface}>(),
);

export const selectOriginalAddress = createAction(
  '[Address] Select original address',
  props<{originalSelected: boolean}>(),
);
